import { IMessageFilter } from "../../interfaces/IMessageFilter";
import DateTimeService from "../../services/DateTimeService";

export class FilterService {

  public static get(isAdmin: boolean, filterData, shouldFilterByCategory, categoriesSelected, numberOfItems, pagingInfo, component, startDate?: Date, endDate?: Date, showPeriod?: string): IMessageFilter {
    let filter = [];
    const order = [];
    if (component === "ContentOrganizer") {
      filter = this.getContentOrganizerGovernanceFilterData(filterData);
    } else if (component === "ContentCreator") {
      if (filterData) {
        filter = this.getContentCreatorFilterData(filterData);
      }
      order.push({
        field: "LatestModified",
        ascending: true
      });
    } else if (component === "Event") {
      if (filterData) {
        filter = this.getEventData(filterData, isAdmin, startDate, endDate, showPeriod);
      }
      order.push({
        field: "StartDate",
        ascending: isAdmin ? false : true
      });
    } else {
      if (!isAdmin) {
        if (filterData) {
          filter = this.getData(filterData, isAdmin, component);
          //   if (shouldFilterByCategory && !!categoriesSelected && ((filterData.selectedCategories !== undefined && filterData.selectedCategories.length !== 0) || filterData.selectedCategories === undefined)) {
          //     const categoriesFilter = [];
          //     const selectedCategories = categoriesSelected;
          //     if (selectedCategories) {
          //       selectedCategories.forEach((item) => {
          //         categoriesFilter.push({
          //           field: component === "Messages" ? "IAMessageCategories" : "IACategories",
          //           type: "Note",
          //           value: item.defaultLabel,
          //           condition: "Or",
          //           operator: "Contains"
          //         });
          //       });
          //     }
          //     filter.push({
          //       fields: categoriesFilter,
          //       condition: "And"
          //     });
          //   }
        }
        order.push({
          field: component === "Messages" ? "IAMessageStartTime" : "StartDate",
          ascending: false
        });
      } else {
        if (filterData) {
          filter = this.getData(filterData, isAdmin, component);
        }
        if (shouldFilterByCategory && !!categoriesSelected) {
          const categoriesFilter = [];
          const selectedCategories = categoriesSelected;
          if (selectedCategories) {
            selectedCategories.forEach((item) => {
              categoriesFilter.push({
                field: component === "Messages" ? "IAMessageCategories" : "IACategories",
                type: "Note",
                value: item.id,
                condition: "Or",
                operator: "Contains"
              });
            });
          }
          filter.push({
            fields: categoriesFilter,
            condition: "And"
          });
        }
        order.push({
          field: component === "Messages" ? "IAMessageStartTime" : "StartDate",
          ascending: false
        });
      }
    }
    if (!isAdmin && (component !== "ContentCreator" || component !== "ContentOrganizer")) {
      filter.push({
        fields: [
          {
            field: "IADraft",
            value: 0,
            condition: "Or",
            operator: "Equal"
          },
          {
            field: "IADraft",
            value: null,
            condition: "Or",
            operator: "IsNull"
          }
        ],
        condition: "And"
      });
      if (component === "Messages") {
        filter.push({
          fields: [
            {
              field: "IAApprovalStatus",
              type: "Text",
              value: "Approved",
              condition: "Or",
              operator: "Equal"
            },
            {
              field: "IAApprovalStatus",
              type: "Text",
              value: null,
              condition: "Or",
              operator: "IsNull"
            }
          ],
          condition: "And"
        });
      }
    } else if (isAdmin && filterData?.onlyShowPublished && component !== "ContentCreator" && component !== "ContentOrganizer") {
      filter.push({
        fields: [
          {
            field: "IADraft",
            value: 0,
            condition: "Or",
            operator: "Equal"
          },
          {
            field: "IADraft",
            value: null,
            condition: "Or",
            operator: "IsNull"
          }
        ],
        condition: "And"
      });
      filter.push({
        fields: [
          {
            field: component === "Messages" ? "IAMessageEndTime" : "EndDate",
            type: "DateTime",
            value: new Date().toISOString(),
            condition: "Or",
            operator: "GreaterThanOrEqual"
          },
          {
            field: component === "Messages" ? "IAMessageEndTime" : "EndDate",
            type: "DateTime",
            value: "",
            condition: "Or",
            operator: "IsNull"
          }
        ],
        condition: "And"
      });
      filter.push({
        fields: [
          {
            field: component === "Messages" ? "IAMessageStartTime" : "StartDate",
            type: "DateTime",
            value: new Date().toISOString(),
            condition: "Or",
            operator: "LessThanOrEqual"
          },
          {
            field: component === "Messages" ? "IAMessageStartTime" : "StartDate",
            type: "DateTime",
            value: "",
            condition: "Or",
            operator: "IsNull"
          }
        ],
        condition: "And"
      });
      if (component === "Messages") {
        filter.push({
          fields: [
            {
              field: "IAApprovalStatus",
              type: "Text",
              value: "Approved",
              condition: "Or",
              operator: "Equal"
            },
            {
              field: "IAApprovalStatus",
              type: "Text",
              value: null,
              condition: "Or",
              operator: "IsNull"
            }
          ],
          condition: "And"
        });
      }
    }
    if (filterData?.onlyShowPublishedToFeed) {
      filter.push({
        fields: [
          {
            field: "IAFeeds",
            type: "Note",
            value: "",
            condition: "Or",
            operator: "IsNotNull"
          }
        ],
        condition: "And"
      });
    }
    return {
      FilteredBy: filter,
      RowLimit: showPeriod && showPeriod === "fullView" ? 0 : numberOfItems - 1,
      PageInfo: pagingInfo,
      OrderedBy: order
    };
  }

  private static getData(filterData: any, isAdmin: boolean, component: string): any[] {
    const filter = [];
    if (filterData) {
      if (filterData.showOnlyAuthorMessages === "Me") {
        filter.push({
          fields: [{
            field: "Author",
            type: "User",
            value: filterData.showOnlyAuthorMessages,
            condition: 'Or',
            operator: 'Equal'
          }],
          condition: "And"
        });
      }
      if (!!filterData.selectedPeolple) {
        filterData.selectedPeolple.forEach(person => {
          const list = [];
          list.push({
            field: component === "Messages" ? "IAMessageContact" : "Contact",
            type: "User",
            value: person.displayName,
            condition: 'Or',
            operator: 'Includes'
          });
          if (list && list.length > 0) {
            filter.push({
              fields: [...list],
              condition: "And"
            });
          }
        });
      }
      if (filterData.showPeriodMessage === "Period") {
        if (filterData.startDate && !filterData.endDate) {
          const endDate = new Date();
          filter.push({
            fields: [
              {
                field: component === "Messages" ? "IAMessageStartTime" : "StartDate",
                type: "DateTime",
                value: filterData.startDate.toISOString(),
                condition: "And",
                operator: "GreaterThanOrEqual"
              },
              {
                field: component === "Messages" ? "IAMessageStartTime" : "StartDate",
                type: "DateTime",
                value: endDate.toISOString(),
                condition: "And",
                operator: "LessThanOrEqual"
              }
            ],
            condition: "And"
          });
        } else
          if (filterData.endDate && !filterData.startDate) {
            let date = new Date();
            if ((filterData.endDate <= date) && !isAdmin) {
              date = filterData.endDate;
            }
            filter.push({
              fields: [
                {
                  field: component === "Messages" ? "IAMessageStartTime" : "StartDate",
                  type: "DateTime",
                  value: date.toISOString(),
                  condition: "Or",
                  operator: "LessThanOrEqual"
                }
              ],
              condition: "And"
            });
          } else
            if (filterData.endDate && filterData.startDate) {
              filter.push({
                fields: [
                  {
                    field: component === "Messages" ? "IAMessageStartTime" : "StartDate",
                    type: "DateTime",
                    value: filterData.startDate.toISOString(),
                    condition: "And",
                    operator: "GreaterThanOrEqual"
                  },
                  {
                    field: component === "Messages" ? "IAMessageStartTime" : "StartDate",
                    type: "DateTime",
                    value: filterData.endDate.toISOString(),
                    condition: "And",
                    operator: "LessThanOrEqual"
                  }
                ],
                condition: "And"
              });
            } else {
              const startDate = new Date();
              filter.push({
                fields: [
                  {
                    field: component === "Messages" ? "IAMessageEndTime" : "EndDate",
                    type: "DateTime",
                    value: startDate.toISOString(),
                    condition: "Or",
                    operator: "GreaterThanOrEqual"
                  },
                  {
                    field: component === "Messages" ? "IAMessageEndTime" : "EndDate",
                    type: "DateTime",
                    value: "",
                    condition: "Or",
                    operator: "IsNull"
                  }
                ],
                condition: "And"
              });
              filter.push({
                fields: [
                  {
                    field: component === "Messages" ? "IAMessageStartTime" : "StartDate",
                    type: "DateTime",
                    value: startDate.toISOString(),
                    condition: "Or",
                    operator: "LessThanOrEqual"
                  },
                  {
                    field: component === "Messages" ? "IAMessageStartTime" : "StartDate",
                    type: "DateTime",
                    value: "",
                    condition: "Or",
                    operator: "IsNull"
                  }
                ],
                condition: "And"
              });
            }

      } else {
        if (!isAdmin) {
          const startDate = new Date();
          filter.push({
            fields: [
              {
                field: component === "Messages" ? "IAMessageEndTime" : "EndDate",
                type: "DateTime",
                value: startDate.toISOString(),
                condition: "Or",
                operator: "GreaterThanOrEqual"
              },
              {
                field: component === "Messages" ? "IAMessageEndTime" : "EndDate",
                type: "DateTime",
                value: "",
                condition: "Or",
                operator: "IsNull"
              }
            ],
            condition: "And"
          });
          filter.push({
            fields: [
              {
                field: component === "Messages" ? "IAMessageStartTime" : "StartDate",
                type: "DateTime",
                value: startDate.toISOString(),
                condition: "Or",
                operator: "LessThanOrEqual"
              },
              {
                field: component === "Messages" ? "IAMessageStartTime" : "StartDate",
                type: "DateTime",
                value: "",
                condition: "Or",
                operator: "IsNull"
              }
            ],
            condition: "And"
          });
        }
      }
      if (!!filterData.selectedCategories) {
        const list = [];
        filterData.selectedCategories.forEach(term => {
          list.push({
            field: component === "Messages" ? "IAMessageCategories" : "IACategories",
            type: "Note",
            value: term.id,
            condition: 'Or',
            operator: 'Contains'
          });
        });
        if (list && list.length > 0) {
          filter.push({
            fields: [...list],
            condition: "And"
          });
        }
      }
    }
    return filter;
  }

  private static getEventData(filterData: any, isAdmin: boolean, startDate: Date, endDate: Date, showPeriod: string): any[] {
    const dateTimeService: DateTimeService = new DateTimeService();
    const filter = [];
    if (filterData) {
      if (filterData.showOnlyAuthorMessages === "Me") {
        filter.push({
          fields: [{
            field: "Author",
            type: "User",
            value: filterData.showOnlyAuthorMessages,
            condition: 'Or',
            operator: 'Equal'
          }],
          condition: "And"
        });
      }
      if (filterData.showPeriodMessage === "Period") {
        if (filterData.startDate && !filterData.endDate) {
          const defaultEndDate = new Date();
          filter.push({
            fields: [
              {
                field: "StartDate",
                type: "DateTime",
                value: new Date(filterData.startDate).toISOString(),
                condition: "And",
                operator: "GreaterThanOrEqual"
              },
              {
                field: "StarDate",
                type: "DateTime",
                value: new Date(defaultEndDate).toISOString(),
                condition: "And",
                operator: "LessThanOrEqual"
              }
            ],
            condition: "And"
          });
        } else
          if (filterData.endDate && !filterData.startDate) {
            let date = new Date();
            if ((filterData.endDate <= date) && !isAdmin) {
              date = filterData.endDate;
            }
            filter.push({
              fields: [
                {
                  field: "StarDate",
                  type: "DateTime",
                  value: new Date(date).toISOString(),
                  condition: "Or",
                  operator: "LessThanOrEqual"
                }
              ],
              condition: "And"
            });
          } else
            if (filterData.endDate && filterData.startDate) {
              filter.push({
                fields: [
                  {
                    field: "StartDate",
                    type: "DateTime",
                    value: new Date(filterData.startDate).toISOString(),
                    condition: "And",
                    operator: "GreaterThanOrEqual"
                  },
                  {
                    field: "StartDate",
                    type: "DateTime",
                    value: new Date(filterData.endDate).toISOString(),
                    condition: "And",
                    operator: "LessThanOrEqual"
                  }
                ],
                condition: "And"
              });
            } else {
              const defaultStartDate = new Date();
              filter.push({
                fields: [
                  {
                    field: "EndDate",
                    type: "DateTime",
                    value: new Date(defaultStartDate).toISOString(),
                    condition: "Or",
                    operator: "GreaterThanOrEqual"
                  },
                  {
                    field: "EndDate",
                    type: "DateTime",
                    value: "",
                    condition: "Or",
                    operator: "IsNull"
                  }
                ],
                condition: "And"
              });
              filter.push({
                fields: [
                  {
                    field: "StartDate",
                    type: "DateTime",
                    value: new Date(defaultStartDate).toISOString(),
                    condition: "Or",
                    operator: "LessThanOrEqual"
                  },
                  {
                    field: "StartDate",
                    type: "DateTime",
                    value: "",
                    condition: "Or",
                    operator: "IsNull"
                  }
                ],
                condition: "And"
              });
            }
      } else {
        if (!isAdmin) {
          if (showPeriod === "day" || showPeriod === "week" || showPeriod === "month") {
            filter.push({
              fields: [
                {
                  field: "EndDate",
                  type: "DateTime",
                  value: `${dateTimeService.ConvertToYYYYMMDD(startDate)}T00:00:00.000Z`,
                  condition: "And",
                  operator: "GreaterThanOrEqual"
                },
                {
                  field: "StartDate",
                  type: "DateTime",
                  value: `${dateTimeService.ConvertToYYYYMMDD(endDate)}T23:59:59.000Z`,
                  condition: "And",
                  operator: "LessThanOrEqual"
                }
              ],
              condition: "And"
            });
          } else if (showPeriod === "upcomming") {
            filter.push({
              fields: [
                {
                  field: "EndDate",
                  type: "DateTime",
                  value: new Date(startDate).toISOString(),
                  condition: "Or",
                  operator: "GreaterThanOrEqual"
                }
              ]
            });
          } else {
            const defaultStartDate = new Date();
            filter.push({
              fields: [
                {
                  field: "EndDate",
                  type: "DateTime",
                  value: new Date(defaultStartDate).toISOString(),
                  condition: "Or",
                  operator: "GreaterThanOrEqual"
                },
                {
                  field: "EndDate",
                  type: "DateTime",
                  value: "",
                  condition: "Or",
                  operator: "IsNull"
                }
              ],
              condition: "And"
            });
          }
        }
      }
      if (!!filterData.selectedCategories) {
        const list = [];
        filterData.selectedCategories.forEach(term => {
          list.push({
            field: "IACategories",
            type: "Note",
            value: (!term.defaultLabel ? term.name : term.defaultLabel) ?? term.id,
            condition: 'Or',
            operator: 'Contains'
          });
        });
        if (list && list.length > 0) {
          filter.push({
            fields: [...list],
            condition: "And"
          });
        }
      }
    }
    // if (!isAdmin) {
    //   filter.push({
    //     fields: [
    //       {
    //         field: "IADraft",
    //         value: 0,
    //         condition: "Or",
    //         operator: "Equal"
    //       },
    //       {
    //         field: "IADraft",
    //         value: null,
    //         condition: "Or",
    //         operator: "IsNull"
    //       }
    //     ],
    //     condition: "And"
    //   });
    // }
    return filter;
  }

  private static getContentCreatorFilterData(filterData: any): any[] {
    const filter = [];
    if (filterData) {
      if (filterData.selectedInstances) {
        const list = [];
        filterData.selectedInstances.forEach(term => {
          if (term !== undefined) {
            list.push({
              field: "instances",
              type: "Note",
              value: term.guid,
              condition: 'Or',
              operator: 'Contains'
            });
            if (term.guid === "IntraActive-Messages-Default") {
              list.push({
                field: "instances",
                type: "Note",
                value: "IntraActive-Messages-IAMessages",
                condition: 'Or',
                operator: 'Contains'
              });
            }
          }
        });
        if (list && list.length > 0) {
          filter.push({
            fields: [...list],
            condition: "And"
          });
        }
      }
      if (filterData.selectedItemStatus) {
        const list = [];
        filterData.selectedItemStatus.forEach(term => {
          if (term !== undefined) {
            list.push({
              field: "status",
              type: "Note",
              value: term.item.id,
              condition: 'Or',
              operator: 'Contains'
            });
          }
        });
        if (list && list.length > 0) {
          filter.push({
            fields: [...list],
            condition: "And"
          });
        }
      }
      if (filterData.selectedTypesOfContent) {
        const list = [];
        filterData.selectedTypesOfContent.forEach(term => {
          if (term !== undefined) {
            list.push({
              field: "types",
              type: "Note",
              value: term.id,
              condition: 'Or',
              operator: 'Contains'
            });
          }
        });
        if (list && list.length > 0) {
          filter.push({
            fields: [...list],
            condition: "And"
          });
        }
      }
      if (filterData.showPeriodMessage === "Period") {
        if (filterData.startDate && !filterData.endDate) {
          const defaultEndDate = new Date();
          filter.push({
            fields: [
              {
                field: "startdate",
                type: "DateTime",
                value: new Date(filterData.startDate).toISOString(),
                condition: "And",
                operator: "GreaterThanOrEqual"
              }
            ]
          });
          filter.push({
            fields: [
              {
                field: "enddate",
                type: "DateTime",
                value: new Date(defaultEndDate).toISOString(),
                condition: "And",
                operator: "LessThanOrEqual"
              }
            ]
          });
        } else
          if (filterData.endDate && !filterData.startDate) {
            const startDate = new Date();
            let endDate = new Date();

            startDate.setFullYear(startDate.getFullYear() - 1);
            if (filterData.endDate <= endDate) {
              endDate = filterData.endDate;
            }
            filter.push({
              fields: [
                {
                  field: "startdate",
                  type: "DateTime",
                  value: new Date(startDate).toISOString(),
                  condition: "And",
                  operator: "GreaterThanOrEqual"
                }
              ]
            });
            filter.push({
              fields: [
                {
                  field: "enddate",
                  type: "DateTime",
                  value: new Date(endDate).toISOString(),
                  condition: "Or",
                  operator: "LessThanOrEqual"
                }
              ]
            });
          } else
            if (filterData.endDate && filterData.startDate) {
              filter.push({
                fields: [
                  {
                    field: "startdate",
                    type: "DateTime",
                    value: new Date(filterData.startDate).toISOString(),
                    condition: "And",
                    operator: "GreaterThanOrEqual"
                  }
                ]
              });
              filter.push({
                fields: [
                  {
                    field: "enddate",
                    type: "DateTime",
                    value: new Date(filterData.endDate).toISOString(),
                    condition: "And",
                    operator: "LessThanOrEqual"
                  }
                ]
              });
            }
      }
    }
    return filter;
  }

  private static getContentOrganizerGovernanceFilterData(filterData: any): any[] {
    const filter = [];
    if (filterData) {
      if (filterData.selectedRevisionDateStatus) {
        const list = [];
        filterData.selectedRevisionDateStatus.forEach(term => {
          if (term !== undefined) {
            list.push({
              field: "status",
              type: "Note",
              value: term.id,
              condition: 'Or',
              operator: 'Contains'
            });
          }
        });
        if (list && list.length > 0) {
          filter.push({
            fields: [...list],
            condition: "And"
          });
        }
      }
      if (filterData.selectedContentOrganizerInstance) {
        const list = [];
        filterData.selectedContentOrganizerInstance.forEach(term => {
          if (term !== undefined) {
            list.push({
              field: "instances",
              type: "Note",
              value: term.id,
              condition: 'Or',
              operator: 'Contains'
            });
          }
        });
        if (list && list.length > 0) {
          filter.push({
            fields: [...list],
            condition: "And"
          });
        }
      }
      if (filterData.selectedContentResponsible) {
        const list = [];
        filterData.selectedContentResponsible.forEach(term => {
          if (term !== undefined) {
            list.push({
              field: "contentresponsible",
              type: "Note",
              value: term.id,
              condition: 'Or',
              operator: 'Contains'
            });
          }
        });
        if (list && list.length > 0) {
          filter.push({
            fields: [...list],
            condition: "And"
          });
        }
      }
      if (filterData.showPeriod === "Period") {
        if (filterData.startDate && !filterData.endDate) {
          const defaultEndDate = new Date();
          filter.push({
            fields: [
              {
                field: "startdate",
                type: "DateTime",
                value: new Date(filterData.startDate).toISOString(),
                condition: "And",
                operator: "GreaterThanOrEqual"
              }
            ]
          });
          filter.push({
            fields: [
              {
                field: "enddate",
                type: "DateTime",
                value: new Date(defaultEndDate).toISOString(),
                condition: "And",
                operator: "LessThanOrEqual"
              }
            ]
          });
        } else
          if (filterData.endDate && !filterData.startDate) {
            const startDate = new Date();
            let endDate = new Date();

            startDate.setFullYear(startDate.getFullYear() - 1);
            if (filterData.endDate <= endDate) {
              endDate = filterData.endDate;
            }
            filter.push({
              fields: [
                {
                  field: "startdate",
                  type: "DateTime",
                  value: new Date(startDate).toISOString(),
                  condition: "And",
                  operator: "GreaterThanOrEqual"
                }
              ]
            });
            filter.push({
              fields: [
                {
                  field: "enddate",
                  type: "DateTime",
                  value: new Date(endDate).toISOString(),
                  condition: "Or",
                  operator: "LessThanOrEqual"
                }
              ]
            });
          } else
            if (filterData.endDate && filterData.startDate) {
              filter.push({
                fields: [
                  {
                    field: "startdate",
                    type: "DateTime",
                    value: new Date(filterData.startDate).toISOString(),
                    condition: "And",
                    operator: "GreaterThanOrEqual"
                  }
                ]
              });
              filter.push({
                fields: [
                  {
                    field: "enddate",
                    type: "DateTime",
                    value: new Date(filterData.endDate).toISOString(),
                    condition: "And",
                    operator: "LessThanOrEqual"
                  }
                ]
              });
            }
      }
    }


    return filter;
  }

  public static parseFilterDataToQueryString(filter: IMessageFilter): string {
    let queryString: string = "";
    if (filter.FilteredBy.length > 0) {
      const filteredBy = filter.FilteredBy;
      for (let i = 0; i < filteredBy.length; i++) {
        const filterParams = filteredBy[i].fields.length;
        for (let j = 0; j < filterParams; j++) {
          const param = filteredBy[i].fields[j];
          queryString += (j === 0) ? `&${param.field}=${param.value}` : (param.value ? `,${param.value}` : "");
        }
      }
    }
    return queryString;
  }
}

